"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAbsoluteUrl = exports.getUrlSearchOfCredential = void 0;
function getUrlSearchOfCredential(flowCredential) {
    const isVelocityCredential = flowCredential.velocityCredential != null &&
        !flowCredential.sertifierCredential;
    return isVelocityCredential ? "velocity=true" : "";
}
exports.getUrlSearchOfCredential = getUrlSearchOfCredential;
function toAbsoluteUrl(url) {
    return url.startsWith("http") ? url : `https://${url}`;
}
exports.toAbsoluteUrl = toAbsoluteUrl;
